const userInteractionChevronStyles = {
	'::after': {
		content: '""',
		display: 'inline-block',
		width: '0.5rem',
		height: '0.625rem',
		marginLeft: '0.5rem',
		backgroundColor: 'primary.main',
		clipPath: 'polygon(26% 0%, 11% 12%, 59% 50%, 11% 88%, 26% 100%, 88% 50%)',
		verticalAlign: 'middle',
	},
};

const userInteractionCopyStyles = {
	ul: {
		listStyleType: 'none',
		margin: 0,
		paddingLeft: 0,
		textAlign: 'left',
		color: 'text.secondary',
		'li:first-child': { color: 'text.primary' },
		'li:nth-child(n+2)': {
			'> strong': {
				color: 'success.dark',
				fontWeight: 'normal',
			},
			'> em': {
				color: 'accent01.dark',
				fontStyle: 'normal',
			},
		},
	},
};

const userInteractionDisabledStyles = {
	'&.Mui-disabled': {
		borderColor: 'neutrals.disabled',
		ul: { color: 'text.disabled' },
		'li:first-child': { color: 'text.disabled' },
		'li:nth-child(n+2)': {
			'> strong': { color: 'text.disabled' },
			'> em': { color: 'text.disabled' },
		},
		'::after': { backgroundColor: 'neutrals.disabled' },
	},
};

export const userInteractionExpansiveStyles = {
	'&.user-interaction-expansive-root': {
		display: 'flex',
		flexDirection: 'row',
		border: '0.0625rem solid',
		borderColor: 'neutrals.primary',
		padding: '0.5rem',
		borderRadius: '1rem',
		':hover': { borderColor: 'secondary.main' },
		'.MuiTypography-root': {
			flex: 1,
		},
		'.MuiSvgIcon-root + .MuiTypography-root': {
			paddingLeft: '0.5rem',
		},
		...userInteractionCopyStyles,
		...userInteractionChevronStyles,
		...userInteractionDisabledStyles,
	},
};
